import initialState from './initialState';
import { FETCH_CONTACTS } from '../actions/actionTypes';

export default function contacts(state = initialState.contacts, action) {
  switch (action.type) {
    case FETCH_CONTACTS:
      return action.contacts;
    default:
      return state;
  }
}
